import { CMSSection } from '@/features/cms/components/CMS/CMSSection'
import { type CMSPageDataWithSpecificLayout } from '@/features/cms/components/CMS/types'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { CMSModalSection } from '@/features/cms/components/CMS/CMSModalSection'
import { layoutEagerComponents } from '@/features/cms/components/CMS/components/Layouts/LayoutEagerComponents'

/**
 * This component corresponds to the `global_home_page_layout` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/global_home_page_layout
 * - **Production** - https://cms.shipt.com/content-type/pool/global_home_page_layout
 */
export const GlobalHomePageLayout = ({
  layoutData: { id, content_type_id, data },
  suppressCmsModal = false,
}: {
  layoutData: CMSPageDataWithSpecificLayout<'global_home_page_layout'>['content']
  suppressCmsModal: boolean
}) => {
  const sectionAandB = (data?.body_section_a ?? []).concat(data?.body_section_b ?? [])
  return (
    <div {...getCMSWrapperProps({ content_type_id, id })}>
      <CMSSection section={sectionAandB} layoutEagerComponents={layoutEagerComponents} />
      <CMSModalSection section={data?.modal ?? []} suppress={suppressCmsModal} />
    </div>
  )
}
